<template>
  <div
    class="notifier">
    <transition-group
      class="notifier-group"
      name="notifier_fade"
      tag="div"
      :duration="animation_dur">
      <div v-for="message in getNotifications"
           class="notifier_item cursor_pointer"
           v-show="message.visible"
           :class="`notifier_${message.type} ${message.visible ? 'visible' : ''}`"
           @click="actionRemoveNotification(message)"
           :key="`message_${message.id}`">
        <div
          class="notifier_message"
          v-html="message.message"
          :class="`notifier_${message.type}`">
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'
import {NOTIFY_ANIMATION_DURATION} from "../../store/modules/notifiocation";

export default {
  name: 'NotifierBlock',
  computed: {
    ...mapGetters([
      'getNotifications'
    ]),
    animation_dur () {
      return NOTIFY_ANIMATION_DURATION
    }
  },
  methods: {
    ...mapActions([
      'actionRemoveNotification'
    ])
  }
}
</script>
